module.exports = __webpack_public_path__ + "static/img/supermokey.7be1310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/supermokey.png
// module id = 8bgY
// module chunks = 34